import * as React from 'react';
import { cutString } from 'utils/strings';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type Props = {
  lengthOfTextDisplay: number;
  text: string;
};
type State = {
  isShowMore: boolean;
};
export class ReadMore extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      isShowMore: false,
    };
  }

  onReadMoreClick() {
    this.setState({
      isShowMore: !this.state.isShowMore,
    });
  }

  render() {
    const { lengthOfTextDisplay, text } = this.props;
    if (text.length <= lengthOfTextDisplay) {
      return <StyledText>{text}</StyledText>;
    }
    return (
      <StyledText>
        {this.state.isShowMore ? text : cutString(text, lengthOfTextDisplay)}
        <a
          style={{ textDecoration: 'none' }}
          onClick={this.onReadMoreClick.bind(this)}
        >
          {' '}
          {!this.state.isShowMore && <FormattedMessage id="ReadMore" />}
        </a>
      </StyledText>
    );
  }
}

const StyledText = styled.p`
  word-break: break-word;
`;



// WEBPACK FOOTER //
// ./app/components/antd/ReadMore.tsx